import Vue from 'vue'
// import Vuetify from 'vuetify'

import {
	Vuetify,
	VApp,
	VAlert,
	VAvatar,
	VBadge,
	VBottomNav,
	VBtn,
	VCard,
	VCheckbox,
	VCombobox,
	VChip,
	VDataTable,
	VDatePicker,
	VDialog,
	VDivider,
	VExpansionPanel,
	VForm,
	VGrid,
	VIcon,
	VImg,
	VList,
	VMenu,
	VNavigationDrawer,
	VPicker,
	VProgressCircular,
	VRadioGroup,
	VSelect,
	VSnackbar,
	VStepper,
	VTabs,
	VTextField,
	VTextarea,
	VToolbar,
	VTooltip,
	VSpeedDial,
	transitions
} from 'vuetify'

Vue.use(Vuetify, {
	components: {
		VApp,
		VAlert,
		VAvatar,
		VBadge,
		VBottomNav,
		VBtn,
		VCard,
		VCheckbox,
		VCombobox,
		VChip,
		VDataTable,
		VDatePicker,
		VDialog,
		VDivider,
		VExpansionPanel,
		VForm,
		VGrid,
		VIcon,
		VImg,
		VList,
		VMenu,
		VNavigationDrawer,
		VPicker,
		VProgressCircular,
		VRadioGroup,
		VSelect,
		VSnackbar,
		VStepper,
		VTabs,
		VTextField,
		VTextarea,
		VToolbar,
		VTooltip,
		VSpeedDial,
		transitions
	},
	theme: {
		primary: '#74cbf1',
		secondary: '#424242',
		yellow: '#f5e933',
		accent: '#9cdffc',
		error: '#de6455',
		info: '#74cbf1',
		success: '#25e684',
		warning: '#fd9827',
		link: '#74cbf1'
	}
})
